import { get } from './requests';

const ROUTE = '/history';

export const getHistory = () =>
    get(ROUTE, undefined, {
        message: 'Failed to fetch history.',
    });
